import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { LINKS } from '@/constants/links';
import { Button } from '@/components/buttons';
import { CareerBoxes } from '@/components/boxes';
import { Text, Headline } from '@/components/typography';
import { Job } from '@/types/job';
interface CareerProps {
  jobs: Job[];
  jobsCount: string;
}
export function Career(t0) {
  const $ = _c(29);
  const {
    jobs,
    jobsCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["aboutUs"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("career.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <SectionHeadline className="mb-4 lg:mb-6" variant="inverted" anchorKey="career.title">{t2}</SectionHeadline>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("career.text");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Text variant="p2" className="text-light-gray-100 text-center">{t4}</Text>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== jobsCount || $[10] !== t) {
    t6 = <Headline variant="h6" as="h3" anchorKey="career.subtitle" className="mb-4 text-white lg:mb-6"><Trans t={t} i18nKey="career.subtitle">{jobsCount}</Trans></Headline>;
    $[9] = jobsCount;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== jobs) {
    t7 = <CareerBoxes items={jobs} />;
    $[12] = jobs;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div>{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = LINKS();
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = t9.career;
  let t11;
  if ($[18] !== t) {
    t11 = t("career.cta");
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <Button to={t10} testId="aboutUsCareer" analyticsParam="aboutUsCareer" size="lg" variant="primary" align="center">{t11}</Button>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t5 || $[24] !== t8) {
    t13 = <div className="mx-auto flex max-w-192 flex-col gap-12 lg:gap-16">{t5}{t8}{t12}</div>;
    $[22] = t12;
    $[23] = t5;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t3) {
    t14 = <div className="relative z-10 px-4">{t3}{t13}</div>;
    $[26] = t13;
    $[27] = t3;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}